import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const WarningIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M11.6437 3.45156C11.7188 3.325 11.8547 3.25 12 3.25C12.1453 3.25 12.2812 3.325 12.3563 3.45156L21.6516 18.7188C21.7172 18.8266 21.75 18.9484 21.75 19.0703C21.75 19.4453 21.4453 19.75 21.0703 19.75H2.92969C2.55469 19.75 2.25 19.4453 2.25 19.0703C2.25 18.9438 2.28281 18.8219 2.34844 18.7188L11.6437 3.45156ZM9.72187 2.27969L0.426563 17.5469C0.145313 18.0063 0 18.5312 0 19.0703C0 20.6875 1.3125 22 2.92969 22H21.0703C22.6875 22 24 20.6875 24 19.0703C24 18.5312 23.85 18.0063 23.5734 17.5469L14.2781 2.27969C13.7953 1.4875 12.9328 1 12 1C11.0672 1 10.2047 1.4875 9.72187 2.27969ZM13.5 16.75C13.5 16.3522 13.342 15.9706 13.0607 15.6893C12.7794 15.408 12.3978 15.25 12 15.25C11.6022 15.25 11.2206 15.408 10.9393 15.6893C10.658 15.9706 10.5 16.3522 10.5 16.75C10.5 17.1478 10.658 17.5294 10.9393 17.8107C11.2206 18.092 11.6022 18.25 12 18.25C12.3978 18.25 12.7794 18.092 13.0607 17.8107C13.342 17.5294 13.5 17.1478 13.5 16.75ZM13.125 8.125C13.125 7.50156 12.6234 7 12 7C11.3766 7 10.875 7.50156 10.875 8.125V12.625C10.875 13.2484 11.3766 13.75 12 13.75C12.6234 13.75 13.125 13.2484 13.125 12.625V8.125Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default WarningIcon
